import React from 'react';
import '../../../styles/filters-ui.css';

/**
 * Shared search bar for workflow list pages (server-side search).
 */
const ListSearchBar = ({ value, onChange, onClear, placeholder, autoFocus = false }) => (
  <div className="search-section" style={{ marginBottom: '1.5rem' }}>
    <div className="search-box-wrapper">
      <span className="search-icon-lens" aria-hidden="true">🔍</span>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="search-input-clean"
        autoFocus={autoFocus}
      />
      {value ? (
        <button
          type="button"
          className="clear-search-btn-inline"
          onClick={onClear}
          title="Clear search"
        >
          ✕
        </button>
      ) : null}
    </div>
  </div>
);

export default ListSearchBar;
